var map = {
	"./": [
		321,
		9
	],
	"./Content": [
		978,
		9,
		1,
		2,
		0,
		8,
		9,
		264,
		269
	],
	"./Content/": [
		978,
		9,
		1,
		2,
		0,
		8,
		9,
		264,
		269
	],
	"./Content/AllSportsGrid": [
		979,
		9,
		0,
		96
	],
	"./Content/AllSportsGrid.js": [
		979,
		9,
		0,
		96
	],
	"./Content/Announcement": [
		955,
		9,
		8,
		19
	],
	"./Content/Announcement/": [
		955,
		9,
		8,
		19
	],
	"./Content/Announcement/Announcement.dictionary": [
		898,
		3,
		97
	],
	"./Content/Announcement/Announcement.dictionary.json": [
		898,
		3,
		97
	],
	"./Content/Announcement/Announcement.module.scss": [
		980,
		9,
		270
	],
	"./Content/Announcement/components/AnnouncementItem": [
		1045,
		9,
		98
	],
	"./Content/Announcement/components/AnnouncementItem.tsx": [
		1045,
		9,
		98
	],
	"./Content/Announcement/components/AnnouncementTable": [
		1111,
		9,
		99
	],
	"./Content/Announcement/components/AnnouncementTable.tsx": [
		1111,
		9,
		99
	],
	"./Content/Announcement/components/FilterByTime": [
		1112,
		9,
		100
	],
	"./Content/Announcement/components/FilterByTime.tsx": [
		1112,
		9,
		100
	],
	"./Content/Announcement/get-time-to-fetch-utils": [
		1113,
		9,
		101
	],
	"./Content/Announcement/get-time-to-fetch-utils.ts": [
		1113,
		9,
		101
	],
	"./Content/Announcement/index": [
		955,
		9,
		8,
		19
	],
	"./Content/Announcement/index.tsx": [
		955,
		9,
		8,
		19
	],
	"./Content/Announcement/types": [
		897,
		9,
		102
	],
	"./Content/Announcement/types.ts": [
		897,
		9,
		102
	],
	"./Content/Announcement/utils/get-announcements-and-options-utils": [
		1066,
		9,
		103
	],
	"./Content/Announcement/utils/get-announcements-and-options-utils.spec": [
		1150,
		9,
		104
	],
	"./Content/Announcement/utils/get-announcements-and-options-utils.spec.js": [
		1150,
		9,
		104
	],
	"./Content/Announcement/utils/get-announcements-and-options-utils.ts": [
		1066,
		9,
		103
	],
	"./Content/Announcement/utils/get-breadcrumbs-by-match-utils": [
		1044,
		9,
		105
	],
	"./Content/Announcement/utils/get-breadcrumbs-by-match-utils.ts": [
		1044,
		9,
		105
	],
	"./Content/MatchCenter": [
		899,
		9,
		20
	],
	"./Content/MatchCenter/": [
		899,
		9,
		20
	],
	"./Content/MatchCenter/MatchCenter.module.scss": [
		981,
		9,
		271
	],
	"./Content/MatchCenter/index": [
		899,
		9,
		20
	],
	"./Content/MatchCenter/index.tsx": [
		899,
		9,
		20
	],
	"./Content/SportGrid": [
		900,
		9,
		0,
		21
	],
	"./Content/SportGrid/": [
		900,
		9,
		0,
		21
	],
	"./Content/SportGrid/SportGrid.module.scss": [
		982,
		9,
		272
	],
	"./Content/SportGrid/TournamentTable": [
		933,
		9,
		0,
		106
	],
	"./Content/SportGrid/TournamentTable.js": [
		933,
		9,
		0,
		106
	],
	"./Content/SportGrid/index": [
		900,
		9,
		0,
		21
	],
	"./Content/SportGrid/index.jsx": [
		900,
		9,
		0,
		21
	],
	"./Content/StageGrid": [
		901,
		9,
		22
	],
	"./Content/StageGrid/": [
		901,
		9,
		22
	],
	"./Content/StageGrid/StageGrid": [
		877,
		9,
		107
	],
	"./Content/StageGrid/StageGrid.module.scss": [
		934,
		9,
		273
	],
	"./Content/StageGrid/StageGrid.tsx": [
		877,
		9,
		107
	],
	"./Content/StageGrid/index": [
		901,
		9,
		22
	],
	"./Content/StageGrid/index.ts": [
		901,
		9,
		22
	],
	"./Content/components/GridHeader": [
		865,
		9,
		108
	],
	"./Content/components/GridHeader.tsx": [
		865,
		9,
		108
	],
	"./Content/components/SportsGrid": [
		931,
		9,
		0,
		109
	],
	"./Content/components/SportsGrid.module.scss": [
		932,
		9,
		274
	],
	"./Content/components/SportsGrid.tsx": [
		931,
		9,
		0,
		109
	],
	"./Content/components/TournamentTable": [
		896,
		9,
		0,
		110
	],
	"./Content/components/TournamentTable.js": [
		896,
		9,
		0,
		110
	],
	"./Content/index": [
		978,
		9,
		0,
		8,
		112
	],
	"./Content/index.tsx": [
		978,
		9,
		0,
		8,
		112
	],
	"./Live": [
		1151,
		9,
		0,
		8,
		135
	],
	"./Live.dictionary": [
		345,
		3
	],
	"./Live.dictionary.json": [
		345,
		3
	],
	"./Live.explanation": [
		1152,
		9,
		136
	],
	"./Live.explanation.ts": [
		1152,
		9,
		136
	],
	"./Live.tsx": [
		1151,
		9,
		0,
		8,
		135
	],
	"./LiveDeferred": [
		375,
		9
	],
	"./LiveDeferred.tsx": [
		375,
		9
	],
	"./actions": [
		128,
		9
	],
	"./actions/": [
		128,
		9
	],
	"./actions/index": [
		128,
		9
	],
	"./actions/index.js": [
		128,
		9
	],
	"./actions/liveHub": [
		117,
		9
	],
	"./actions/liveHub.ts": [
		117,
		9
	],
	"./constants": [
		1107,
		9,
		256
	],
	"./constants.ts": [
		1107,
		9,
		256
	],
	"./index": [
		321,
		9
	],
	"./index.tsx": [
		321,
		9
	],
	"./reducer": [
		297,
		9
	],
	"./reducer/": [
		297,
		9
	],
	"./reducer/entities": [
		357,
		9
	],
	"./reducer/entities.ts": [
		357,
		9
	],
	"./reducer/index": [
		297,
		9
	],
	"./reducer/index.js": [
		297,
		9
	],
	"./reducer/presentation": [
		358,
		9
	],
	"./reducer/presentation.js": [
		358,
		9
	],
	"./selectors/entities": [
		203,
		9
	],
	"./selectors/entities.ts": [
		203,
		9
	],
	"./selectors/gridPresentation": [
		834,
		9,
		0,
		257
	],
	"./selectors/gridPresentation.ts": [
		834,
		9,
		0,
		257
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1281;
module.exports = webpackAsyncContext;